<template>
  <v-card outlined elevation="1">
    <v-card-title>{{ title }}</v-card-title>
    <v-card-text>
      <slot />
    </v-card-text>
  </v-card>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  name: 'VCardImportFormSection',

  props: {
    title: {
      type: String,
      required: true,
    },
  }
});
</script>
